import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnTextField,
  columnNumberField,
  columnPriceField,
  columnDateField,
} from "utils/tables-utils";

const columnModel = [
  columnTextField(
    {
      dataField: "LinhaProduto",
      text: "Linha do Produto",
      csvText: "LinhaProduto",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "IdProduto",
      text: "Código do Produto",
      csvText: "CodigoProduto",
    },
    true
  ),
  columnTextField(
    {
      dataField: "NomeProduto",
      text: "Nome do Produto",
      csvText: "NomeProduto",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "PrecoAnterior",
      text: "Preço Comparação",
      csvText: "PrecoAnterior",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "PrecoAtual",
      text: "Preço Atual",
      csvText: "PrecoAtual",
    },
    true
  ),
  columnDateField(
    {
      dataField: "DataAtualizacao",
      text: "Data Última Atualização",
      csvText: "DataAtualizacao",
    },
    true
  ),
];

export default function TableHistoricPrices({ dataTable }) {
  return (
    <ToolkitTable
      searched={Boolean(dataTable)}
      keyField="IdProduto"
      dataTable={dataTable}
      columnModel={columnModel}
      headerTitle={`Histórico de Alteração de Preços`}
      csvFileName="HistoricoDeAlteracaoDePrecos.csv"
      pagination={{
        options: [25, 50, 100],
        defaultOption: 25,
      }}
      showPrint
      notFoundTitle="Não há histórico de alteração de preços no período."
    />
  );
}
